import axios from 'axios'
import jwtToken from './getJwtToken'
import { errorHandler } from './errorHandler'
import { locale } from './locale'

const PAYOUTS_API_URL = process.env.VUE_APP_PAYOUTS_API_URL

const payoutsApi = axios.create({
  baseURL: `${PAYOUTS_API_URL}/api/me`,
  headers: {
    Authorization: `Bearer ${jwtToken}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': locale,
  },
})

payoutsApi.interceptors.response.use(
  response => response,
  error => errorHandler(error),
)

payoutsApi.interceptors.request.use(
  request => request,
  error => errorHandler(error),
)

export default payoutsApi
